/**
 * Service for action logs management
 */export class ActionLogsService{constructor(api){this.api=void 0;this.basePath='/api/action-logs';this.api=api;}/**
   * Fetch action logs with pagination
   */async fetchLogs(params){return this.api.get(this.basePath,params);}}